import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
})
export class PieChartComponent implements OnInit {
  @Input() data: any;
  @Input() from: string;
  title: String;

  estados = [];
  colorScheme = {
    domain: [
      'whitesmoke',
      'white',
      'yellow',
      'orange',
      'greenyellow',
      'green',
      'blue ',
    ],
  };
  colorSchema = {
    domain: ['#00e800', ' #ff0000 '],
  };
  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    let lang = this.translate.currentLang;
    if (lang == 'es') {
      this.title = 'Fechas';
    } else {
      this.title = 'Dates';
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.estados = [];
    if (this.data.length != 0) {
      this.estados.push({
        name: this.translate.instant(
          'action_plan.statistics.graphics.status_on_date',
          { value: this.data.en_fecha }
        ),
        value: this.data.en_fecha,
      });
      this.from == 'general'
        ? this.estados.push({
            name: this.translate.instant(
              'action_plan.statistics.graphics.status_not_on_date',
              { value: this.data.no_en_fecha }
            ),
            value: this.data.no_en_fecha,
          })
        : this.estados.push({
            name: this.translate.instant(
              'action_plan.statistics.graphics.status_not_on_date',
              { value: this.data.no_en_Fecha }
            ),
            value: this.data.no_en_Fecha,
          });
    }
  }
}
